import { z } from 'zod';


export const editSecurityGroupingFormSchema = z.object({
  code: z
    .string()
    .trim()
    .max(30, 'securityGrouping:validation.codeMaxLength')
    .optional()
    .default(''),
  groupName: z
    .string()
    .trim()
    .min(1, 'securityGrouping:validation.groupNameRequired')
    .max(100, 'securityGrouping:validation.groupNameMaxLength'),
  sendsAttendanceStatus: z.boolean().default(false),
});

export type EditSecurityGroupingFormValues = z.infer<typeof editSecurityGroupingFormSchema>;
